import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class SignUpAsCompanyRequest {
  @jsonMember(String)
  public username!: string;

  @jsonMember(String)
  public password!: string;

  @jsonMember(String)
  public email!: string;

  @jsonMember(String)
  public companyName!: string;

  @jsonMember(String)
  public companyNip!: string;

  @jsonMember(Boolean)
  public newsletter!: boolean;

  public constructor(
    username: string,
    password: string,
    email: string,
    name: string,
    nip: string,
    newsletter: boolean,
  ) {
    this.username = username;
    this.password = password;
    this.email = email;
    this.companyName = name;
    this.companyNip = nip;
    this.newsletter = newsletter;
  }
}
